import { Entry } from '@libs/contentful';

import type { VetRxEntry } from '@/entities/vet-rx-content';

import type { VetRxDrawerTypes } from '../ui/types';
import { getVetRxDrawerHeader } from './get-vet-rx-drawer-header';

export const vetRxTitleCats = {
    cold: 'Cold Items',
    rx_med: 'Pharmacy',
    rx_food: 'Veterinary Diets',
};

type GetVetRxDrawerData = {
    title: string;
    bodyHeading?: string;
    body: readonly Entry<{ title: string }>[];
};

export const getVetRxDrawerData = (vetRx: VetRxEntry[], type?: VetRxDrawerTypes): GetVetRxDrawerData => {
    const relevant =
        type && vetRx?.map(vetRxItem => vetRxItem.fields).find(fields => fields?.title === vetRxTitleCats[type]);
    const entries = (relevant?.vetRxContentRepeater as Entry[]) ?? [];

    return {
        title: getVetRxDrawerHeader(type as keyof typeof vetRxTitleCats),
        bodyHeading: relevant?.vetRxHeading as string,
        body: entries as readonly Entry<{ title: string }>[],
    };
};
